/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_OrdersInputs */

const en_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total orders`)
};

const es_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pedidos totales`)
};

const fr_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`commandes totales`)
};

const de_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Bestellungen`)
};

const ja_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総注文数`)
};

const zh_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总订单量`)
};

const ar_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الطلبات`)
};

const id_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total pesanan`)
};

const it_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ordini totali`)
};

const ru_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`всего заказов`)
};

const pt_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total de pedidos`)
};

const ko_total_orders = /** @type {(inputs: Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 주문 수`)
};

/**
* | output |
* | --- |
* | "total orders" |
*
* @param {Total_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const total_orders = /** @type {((inputs?: Total_OrdersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_OrdersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_total_orders(inputs)
	if (locale === "es") return es_total_orders(inputs)
	if (locale === "fr") return fr_total_orders(inputs)
	if (locale === "de") return de_total_orders(inputs)
	if (locale === "ja") return ja_total_orders(inputs)
	if (locale === "zh") return zh_total_orders(inputs)
	if (locale === "ar") return ar_total_orders(inputs)
	if (locale === "id") return id_total_orders(inputs)
	if (locale === "it") return it_total_orders(inputs)
	if (locale === "ru") return ru_total_orders(inputs)
	if (locale === "pt") return pt_total_orders(inputs)
	return ko_total_orders(inputs)
});